export var componentsLocales = {
  forward: 'Forward'
};